import { AbstractScatterVisualization } from '../visualization.abstract.scatter.component';
export class PlsCanonicalGraph extends AbstractScatterVisualization {
}
